<template>
    <div class="account-frame">
        <h1>Mettre à jour le mot de passe</h1>
        <div class="form-section">
            <label>Nouveau mot de passe :</label>
            <div class="password-input-frame">
                <input :type="passwordReadingMode" v-model="password">

                <span class="material-symbols-outlined" @click="toggleVisibility" v-if="show_password">visibility</span>
                <span class="material-symbols-outlined" @click="toggleVisibility" v-else>visibility_off</span>
            </div>

            <ul class="password-validation-list">
                <li :class="{ 'invalid': !validLengthCondition }">
                    <span class="material-symbols-outlined">{{ validLengthCondition ? 'check_circle' :
                        'cancel' }}</span>
                    <span>8 caractères minimum</span>
                </li>

                <li :class="{ 'invalid': !validNumberCondition }">
                    <span class="material-symbols-outlined">{{ validNumberCondition ? 'check_circle' :
                        'cancel' }}</span>
                    <span>1 chiffre</span>
                </li>

                <li :class="{ 'invalid': !validSpecialCarCondition }">
                    <span class="material-symbols-outlined">{{ validSpecialCarCondition ? 'check_circle' :
                        'cancel' }}</span>
                    <span>1 caractère spécial</span>
                </li>
            </ul>
        </div>

        <div class="form-section">
            <label>Confirmez le mot de passe :</label>
            <div class="password-input-frame">
                <input :type="passwordReadingMode" v-model="password2">

                <span class="material-symbols-outlined" @click="toggleVisibility" v-if="show_password">visibility</span>
                <span class="material-symbols-outlined" @click="toggleVisibility" v-else>visibility_off</span>
            </div>
        </div>

        <div class="btn" @click="resetPassword">Envoyer</div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            password: "",
            password2: "",
            show_password: false,
        }
    },
    methods: {
        toggleVisibility() {
            this.show_password = !this.show_password;
        },
        async resetPassword() {
            if (this.password != this.password2) {
                this.errMsg = "Veuillez saisir deux mots de passe identiques";
            } else if (
                this.validLengthCondition
                && this.validNumberCondition
                && this.validSpecialCarCondition
            ) {
                try {
                    const res = await axios.put(this.$store.getters.get_api_url + 'auth/reset-password/', {
                        newPassword: this.password,
                        token: this.$route.query.reset_token
                    });

                    const token = res.data.token;
                    const refresh_token = res.data.refresh_token;

                    localStorage.setItem('refresh_token', refresh_token);
                    this.$store.commit('setToken', token);

                    this.$store.commit('changeValidationMsg', "Mot de passe modifié avec succès");
                    this.$router.replace('/client');
                } catch (err) {
                    this.$store.commit('changeErrorMsg', err.message);
                }
            }
        },
    },
    computed: {
        hasPasswordResetDemand() {
            return this.$route.query.reset_token != undefined;
        },
        validLengthCondition() {
            return this.password.length >= 8;
        },
        validNumberCondition() {
            return /\d/.test(this.password);
        },
        validSpecialCarCondition() {
            return /[^a-zA-Z0-9]/.test(this.password);
        },
        passwordReadingMode() {
            if (this.show_password) {
                return "text"
            } else {
                return 'password'
            }
        },
    },
    mounted() {
        if (this.hasPasswordResetDemand) {
            this.showPasswordResetModale = true;
        }
    }
}
</script>

<style scoped>
.account-frame {
    padding: 20px;
}

.account-frame h1 {
    text-align: center;
    background-color: #296A9D;
    color: white;
    padding: 10px;
}

.account-frame .form-section {
    display: flex;
    flex-direction: column;
}

.account-frame .form-section label,
.account-frame .form-section input {
    font-size: 14px;
    text-align: left;
}

.account-frame .form-section label {
    font-weight: bold;
}

.account-frame .form-section div {
    display: flex;
    align-items: center;
}

.account-frame .form-section div span {
    cursor: pointer;
}

.account-frame p:hover {
    cursor: pointer;
    text-decoration: underline;
}

.account-frame .btn {
    display: block;
    width: 200px;
    background-color: #F4706A;
    color: white;
    text-align: center;
    padding: 10px;
    border-radius: 5px;
    margin: 10px auto;
}

.account-frame .btn:hover {
    background-color: #29B6CE;
}

ul.password-validation-list {
    list-style-type: none;
    padding: 0;
}

ul.password-validation-list li {
    display: flex;
    align-items: center;
    color: green;
}

ul.password-validation-list li.invalid {
    color: red;
}
</style>